import Debounce from '../helpers/debounce.js';
import Headroom from 'headroom.js';

export default () => {
    const bp = 1300;
    const header = document.querySelector('.js-site-header');
    const trigger = document.querySelector('.js-site-header-trigger');
    const nav = document.querySelector('.js-site-nav');
    const navClose = document.querySelector('.js-site-nav-close');
    const mega = document.querySelector('.js-site-mega-menu');
    const search = document.querySelector('.js-site-header-search');

    /**
     *
     * Init Headroom functionality
     *
     */
    // console.log(root.style.getProperty('--site-header-ad-height'));
    const headroom = new Headroom(header, {
        offset: setHeaderHeight(),
        onTop: () => {
            setTimeout(() => {
                setHeaderHeight();
            }, 100);
        },
        onNotTop: () => {
            setTimeout(() => {
                setHeaderHeight();
            }, 100);
        },
    });
    headroom.init();

    setHeaderHeight();
    window.addEventListener(
        'load',
        Debounce(() => setHeaderHeight())
    );
    window.addEventListener(
        'resize',
        Debounce(() => setHeaderHeight())
    );

    /**
     *
     * Navigation
     *
     */
    trigger.addEventListener('click', (e) => {
        trigger.classList.toggle('is-active');
        search.classList.toggle('is-hidden');

        if (window.innerWidth <= bp) {
            nav.classList.toggle('is-active');
        } else {
            mega.classList.toggle('is-active');
        }
    });

    navClose.addEventListener('click', (e) => {
        trigger.classList.remove('is-active');
        search.classList.remove('is-hidden');
        nav.classList.remove('is-active');
        mega.classList.remove('is-active');
    });

    /**
     * Menu Ad movement
     *
     * @param {boolean} bp mobile or desktop
     */
    const breakpointSwitch = (bp = false) => {
        const mobileLocation = document.querySelector(
            `.js-site-header-menu-ad-mobile`
        );
        const desktopLocation = document.querySelector(
            `.js-site-header-menu-ad-desktop`
        );
        const ad =
            mobileLocation.querySelector(`.js-ad`) ??
            desktopLocation.querySelector(`.js-ad`);
        if (bp) {
            mobileLocation.append(ad);

            if (trigger.classList.contains('is-active')) {
                nav.classList.add('is-active');
                mega.classList.remove('is-active');
            }
        } else {
            desktopLocation.append(ad);

            if (trigger.classList.contains('is-active')) {
                nav.classList.remove('is-active');
                mega.classList.add('is-active');
            }
        }
    };

    breakpointSwitch(window.innerWidth <= bp);
    const mql = window.matchMedia(`(max-width: ${bp}px)`);

    mql.addEventListener('change', (e) => {
        breakpointSwitch(e.matches);
    });
};

const setHeaderHeight = () => {
    setHeight(`--site-header-height`, `.js-site-header`);
    setHeight(`--site-header-subnav-height`, `.js-site-header-subnav`);
    const adHeight = setHeight(
        `--site-header-ad-height`,
        `.js-site-header-display-ad`
    );

    return adHeight;
};

const setHeight = (variable, element) => {
    const root = document.documentElement;
    const el = document.querySelector(element);

    if (el) {
        root.style.setProperty(variable, el.offsetHeight + 'px');
        return el.offsetHeight;
    }

    return 0;
};
